/**
 * Montar kit: estado do kit no cliente, barra de progresso (até 5 metas), total, parcelamento e adicionar ao carrinho.
 * Limite por produto: quantidade disponível na loja (variant). Soma kit + carrinho para desabilitar Adicionar e limitar input.
 */
(function () {
  const CART_UPDATE = 'cart:update';

  function getRoot(container) {
    return container.closest('[data-jv-montar-kit]');
  }

  function getEffectiveMaxForWrap(wrap, sectionMax) {
    const cap = parseInt(sectionMax, 10) || 999;
    const variantMax = parseInt(wrap.getAttribute('data-variant-max'), 10);
    let effective = isNaN(variantMax) ? cap : Math.min(cap, variantMax);

    if (window.JVRegionalStock) {
      try {
        const regionalData = JSON.parse(wrap.getAttribute('data-regional-stock') || '0');

        // Novo formato: inteiro unico no metacampo de produto.
        if (typeof regionalData === 'number' || typeof regionalData === 'string') {
          const regionalQty = parseInt(String(regionalData), 10);
          if (!isNaN(regionalQty)) effective = Math.min(effective, Math.max(0, regionalQty));
        }

        // Novo formato estruturado: { total, regions: { sp, sjc, rj } }
        const code = window.JVRegionalStock.getState()?.code;
        if (code && regionalData && typeof regionalData === 'object' && regionalData.regions && typeof regionalData.regions === 'object') {
          const regionalQty = parseInt(regionalData.regions[String(code).toLowerCase()], 10);
          if (!isNaN(regionalQty)) effective = Math.min(effective, Math.max(0, regionalQty));
        }

        // Compatibilidade com formato legado por regiao no root.
        if (code && regionalData && typeof regionalData === 'object') {
          const regionalQty = parseInt(regionalData[String(code).toLowerCase()], 10);
          if (!isNaN(regionalQty)) effective = Math.min(effective, Math.max(0, regionalQty));
        }
      } catch (_) {}
      }
    

    return effective;
  }

  function getGoals(root) {
    const el = root.querySelector('[data-kit-goals]');
    if (!el || !el.textContent) return [];
    try {
      const parsed = JSON.parse(el.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  }

  function formatMoney(cents, currencySymbol) {
    if (cents == null || isNaN(cents)) return (currencySymbol || 'R$') + ' 0,00';
    const value = (cents / 100).toFixed(2);
    const [intPart, decPart] = value.split('.');
    const withDots = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (currencySymbol || '') + ' ' + withDots + ',' + decPart;
  }

  function calculateInstallment(totalCents, installmentsCount, interestPercent) {
    if (!totalCents || !installmentsCount || installmentsCount < 1) return null;
    const total = totalCents / 100;
    const rate = parseFloat(interestPercent) || 0;
    const finalTotal = rate > 0 ? total * (1 + rate / 100) : total;
    return Math.round((finalTotal / installmentsCount) * 100);
  }

  function getKitState(root) {
    if (!root._kitState) root._kitState = [];
    return root._kitState;
  }

  function getTotalItems(kitState) {
    return kitState.reduce((sum, item) => sum + item.quantity, 0);
  }

  function getTotalCents(kitState) {
    return kitState.reduce((sum, item) => sum + item.price * item.quantity, 0);
  }

  function updateProgress(root, goals, totalItems) {
    const msgEl = root.querySelector('[data-kit-progress-message]');
    const trackEl = root.querySelector('[data-kit-progress-track]');
    const fillEl = root.querySelector('[data-kit-progress-fill]');
    if (!trackEl) return;

    const dots = trackEl.querySelectorAll('.jv-montar-kit__progress-dot');
    let reachedCount = 0;
    let maxQty = 0;
    dots.forEach((dot) => {
      const qty = parseInt(dot.dataset.goalQty, 10) || 0;
      if (qty > maxQty) maxQty = qty;
      const reached = totalItems >= qty;
      dot.classList.toggle('reached', reached);
      if (reached) reachedCount++;
    });
    trackEl.setAttribute('aria-valuenow', totalItems);

    if (fillEl && maxQty > 0) {
      const pct = Math.min(100, (totalItems / maxQty) * 100);
      fillEl.style.width = pct + '%';
    }

    if (!msgEl || goals.length === 0) return;

    const total = Number(totalItems) || 0;
    const nextGoal = goals.find((g) => (Number(g.qtyMin) || 0) > total);
    const safe = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

    if (nextGoal) {
      const template = root.dataset.progressMessageTemplate || '';
      if (!template) return;
      const qtyNeeded = (Number(nextGoal.qtyMin) || 0) - total;
      const reward = nextGoal.reward || '';
      msgEl.innerHTML = template.replace('[gift]', '<strong>' + safe(reward) + '</strong>').replace('[qty]', '<strong>' + safe(String(qtyNeeded)) + '</strong>');
    } else {
      const lastGoal = goals[goals.length - 1];
      const lastMsg = root.dataset.lastRewardMessage || 'Parabéns! Você garantiu [prêmio] no seu pedido';
      if (lastGoal && total >= (Number(lastGoal.qtyMin) || 0)) {
        const reward = lastGoal.reward || '';
        msgEl.innerHTML = lastMsg.replace('[prêmio]', '<strong>' + safe(reward) + '</strong>');
      } else {
        msgEl.textContent = '';
      }
    }
  }

  function updateTotalAndInstallments(root, totalCents) {
    const symbol = root.dataset.currencySymbol || '';
    const totalEl = root.querySelector('[data-kit-total]');
    if (totalEl) totalEl.textContent = formatMoney(totalCents, symbol);

    const installmentsEl = root.querySelector('[data-kit-installments]');
    if (installmentsEl) {
      const count = parseInt(root.dataset.installmentsCount, 10) || 12;
      const interest = root.dataset.installmentInterest || '0';
      const installmentCents = calculateInstallment(totalCents, count, interest);
      if (installmentCents != null) {
        const valueStr = formatMoney(installmentCents, symbol);
        installmentsEl.innerHTML = 'ou em até <strong>' + String(count).replace(/</g, '&lt;') + 'x</strong> de <strong>' + valueStr.replace(/</g, '&lt;') + '</strong>';
      } else {
        installmentsEl.textContent = '';
      }
    }
  }

  function renderKitList(root, kitState) {
    const listEl = root.querySelector('[data-kit-list]');
    const emptyEl = root.querySelector('[data-kit-items-empty]');
    const maxKit = parseInt(root.dataset.maxKitItems, 10) || 20;
    if (!listEl) return;

    listEl.innerHTML = '';
    if (kitState.length === 0) return;
    if (emptyEl) emptyEl.classList.add('hidden');

    const symbol = root.dataset.currencySymbol || '';
    kitState.forEach((item, index) => {
      const li = document.createElement('li');
      li.className = 'jv-montar-kit__item';
      li.dataset.variantId = item.variantId;
      li.dataset.index = String(index);
      const imgHtml = item.imageUrl
        ? '<img src="' + item.imageUrl.replace(/"/g, '&quot;') + '" alt="" width="56" height="56" loading="lazy">'
        : '<span class="jv-montar-kit__item-placeholder">' + (item.title ? item.title.charAt(0).toUpperCase() : '') + '</span>';
      const qty = Math.min(Math.max(1, item.quantity), maxKit);
      li.innerHTML =
        '<div class="jv-montar-kit__item-image">' + imgHtml + '</div>' +
        '<div class="jv-montar-kit__item-body">' +
        '<p class="jv-montar-kit__item-title">' + (item.title || '').replace(/</g, '&lt;') + '</p>' +
        '<p class="jv-montar-kit__item-price">' + formatMoney(item.price * qty, symbol) + '</p>' +
        '<div class="jv-montar-kit__item-qty-row">' +
        '<span class="jv-montar-kit__item-meta">Quantidade</span> ' +
        '<span class="jv-montar-kit__item-qty-badge" data-kit-item-qty-badge>' + qty + '</span>' +
        '</div>' +
        '<button type="button" class="jv-montar-kit__item-remove" data-kit-remove aria-label="Remover">remover</button>' +
        '</div>';
      listEl.appendChild(li);
    });
  }

  function updateUI(root) {
    const goals = getGoals(root);
    const kitState = getKitState(root);
    const totalItems = getTotalItems(kitState);
    const totalCents = getTotalCents(kitState);

    updateProgress(root, goals, totalItems);
    updateTotalAndInstallments(root, totalCents);
    renderKitList(root, kitState);

    const cartBtn = root.querySelector('[data-kit-add-to-cart]');
    if (cartBtn) cartBtn.disabled = kitState.length === 0;
  }

  function addToKitFromCard(root, card) {
    const variantId = card.dataset.variantId;
    const price = parseInt(card.dataset.price, 10) || 0;
    const title = card.dataset.title || '';
    const imageUrl = card.dataset.imageUrl || '';
    const addWrap = card.querySelector('[data-kit-add-wrap]');
    const wrap = card.querySelector('[data-kit-quantity-wrap]');
    const input = wrap ? wrap.querySelector('[data-kit-qty-input]') : null;
    let qty = input ? parseInt(input.value, 10) || 1 : 1;

    if (!variantId) return;

    const maxKit = parseInt(root.dataset.maxKitItems, 10) || 20;
    const kitState = getKitState(root);
    const currentTotal = getTotalItems(kitState);
    if (currentTotal + qty > maxKit) return;

    const effectiveMax = addWrap ? parseInt(addWrap.dataset.effectiveMax, 10) : null;
    const cartQty = addWrap ? parseInt(addWrap.dataset.cartQty, 10) || 0 : 0;
    const existing = kitState.find((i) => String(i.variantId) === String(variantId));
    const kitQty = existing ? existing.quantity : 0;
    if (effectiveMax != null && (kitQty + cartQty + qty) > effectiveMax) {
      qty = Math.max(0, effectiveMax - kitQty - cartQty);
      if (qty === 0) return;
    }

    if (existing) {
      existing.quantity += qty;
    } else {
      kitState.push({
        variantId,
        quantity: qty,
        title,
        price,
        imageUrl,
      });
    }

    if (input) input.value = 1;
    updateUI(root);
    updateQuantityLimitsAndButtons(root);
  }

  function removeFromKit(root, variantId) {
    const kitState = getKitState(root);
    const idx = kitState.findIndex((i) => String(i.variantId) === String(variantId));
    if (idx !== -1) {
      kitState.splice(idx, 1);
      updateUI(root);
      updateQuantityLimitsAndButtons(root);
    }
  }

  async function addKitToCart(root, button) {
    const kitState = getKitState(root);
    if (kitState.length === 0) return;

    const items = kitState.map((i) => ({ id: i.variantId, quantity: i.quantity }));
    const cartAddUrl =
      (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';

    button.disabled = true;
    const originalText = button.textContent;

    try {
      const res = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items }),
      });

      const data = await res.json().catch(() => ({}));

      if (res.ok && !data.status) {
        root._kitState = [];
        updateUI(root);
        document.dispatchEvent(
          new CustomEvent(CART_UPDATE, {
            bubbles: true,
            detail: {
              resource: data,
              sourceId: root.dataset.sectionId || '',
              data: { source: 'montar-kit', itemCount: data.item_count },
            },
          })
        );
      } else {
        const message = data.message || data.description || 'Não foi possível adicionar ao carrinho.';
        if (typeof window.alert === 'function') window.alert(message);
      }
    } finally {
      button.disabled = false;
      button.textContent = originalText;
    }
  }

  async function updateQuantityLimitsAndButtons(root) {
    const sectionMax = root.dataset.maxKitItems || '20';
    let cartItems = [];
    try {
      const res = await fetch('/cart.js');
      if (res.ok) {
        const cart = await res.json();
        cartItems = cart.items || [];
      }
    } catch (_) {}

    const kitState = getKitState(root);
    root.querySelectorAll('[data-kit-product-card]').forEach((card) => {
      const variantId = card.dataset.variantId;
      const wrap = card.querySelector('[data-kit-add-wrap]');
      const qtyWrap = card.querySelector('[data-kit-quantity-wrap]');
      const input = qtyWrap ? qtyWrap.querySelector('[data-kit-qty-input]') : null;
      const addBtn = card.querySelector('[data-kit-add]');
      if (!wrap || !variantId) return;

      const effectiveMax = getEffectiveMaxForWrap(wrap, sectionMax);
      const cartQty = cartItems
        .filter((i) => String(i.variant_id) === String(variantId))
        .reduce((s, i) => s + (i.quantity || 0), 0);
      const kitEntry = kitState.find((i) => String(i.variantId) === String(variantId));
      const kitQty = kitEntry ? kitEntry.quantity : 0;

      wrap.dataset.effectiveMax = String(effectiveMax);
      wrap.dataset.cartQty = String(cartQty);

      const effectiveMaxForInput = Math.max(0, effectiveMax - cartQty);
      const min = 1;

      if (input) {
        input.setAttribute('max', String(Math.max(min, effectiveMaxForInput)));
        let v = parseInt(input.value, 10) || min;
        v = Math.max(min, Math.min(effectiveMaxForInput, v));
        input.value = v;
      }

      if (addBtn) {
        const isSoldOutStore = wrap.classList.contains('jv-add-to-kit-wrap--sold-out');
        if (isSoldOutStore) {
          addBtn.disabled = true;
          addBtn.setAttribute('aria-disabled', 'true');
        } else {
          const atLimit = (kitQty + cartQty) >= effectiveMax;
          addBtn.disabled = atLimit;
          addBtn.setAttribute('aria-disabled', atLimit ? 'true' : 'false');
        }
      }
    });
  }

  function setupQuantityButtons(root) {
    root.querySelectorAll('[data-kit-quantity-wrap]').forEach((wrap) => {
      const input = wrap.querySelector('[data-kit-qty-input]');
      const minus = wrap.querySelector('[data-kit-qty-minus]');
      const plus = wrap.querySelector('[data-kit-qty-plus]');
      if (!input || !minus || !plus) return;

      const min = parseInt(input.getAttribute('min'), 10) || 1;

      function getMax() {
        return parseInt(input.getAttribute('max'), 10) || 20;
      }

      function clamp() {
        const max = getMax();
        let v = parseInt(input.value, 10);
        if (isNaN(v)) v = min;
        v = Math.max(min, Math.min(max, v));
        input.value = v;
      }

      minus.addEventListener('click', () => {
        const max = getMax();
        let v = parseInt(input.value, 10) || min;
        input.value = Math.max(min, v - 1);
        clamp();
      });
      plus.addEventListener('click', () => {
        const max = getMax();
        let v = parseInt(input.value, 10) || min;
        input.value = Math.min(max, v + 1);
        clamp();
      });
      input.addEventListener('change', clamp);
    });
  }

  function initSection(sectionRoot) {
    if (!sectionRoot || sectionRoot.dataset.montarKitInit === 'true') return;
    sectionRoot.dataset.montarKitInit = 'true';

    setupQuantityButtons(sectionRoot);
    updateUI(sectionRoot);
    updateQuantityLimitsAndButtons(sectionRoot);

    sectionRoot.querySelectorAll('[data-kit-add]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const card = btn.closest('[data-kit-product-card]');
        if (card) addToKitFromCard(sectionRoot, card);
      });
    });

    sectionRoot.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('[data-kit-remove]');
      if (removeBtn) {
        const item = removeBtn.closest('.jv-montar-kit__item');
        if (item && item.dataset.variantId) removeFromKit(sectionRoot, item.dataset.variantId);
      }
    });

    const cartBtn = sectionRoot.querySelector('[data-kit-add-to-cart]');
    if (cartBtn) {
      cartBtn.addEventListener('click', () => addKitToCart(sectionRoot, cartBtn));
    }
  }

  function init() {
    document.querySelectorAll('[data-jv-montar-kit]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-jv-montar-kit]');
    if (root) initSection(root);
  });

  document.addEventListener(CART_UPDATE, () => {
    document.querySelectorAll('[data-jv-montar-kit]').forEach(updateQuantityLimitsAndButtons);
  });
  document.addEventListener('jv:region-changed', () => {
    document.querySelectorAll('[data-jv-montar-kit]').forEach(updateQuantityLimitsAndButtons);
  });
})();
